export interface IProgressStep {
  name: string;
  route: string;
  isCompleted: boolean;
  progress: number;
  isCustomStep: boolean;
}

export enum ProgressValues {
  Zero = 0,
  Ten = 10,
  Thirty = 30,
  Forty = 40,
  Fifty = 50,
  Seventy = 70,
  OneHundred = 100
}

export enum BarPosition {
  Start = 'start',
  Middle = 'middle',
  End = 'end'
}

export const ProgressStyles = {
  borderRadiusStart: 'border-radius-start',
  borderRadiusEnd: 'border-radius-end',
  borderRadiusMiddle: 'border-radius-middle',
  progressMargin: 'progress-margin',
  redBackground: 'red-background',
  greyBackground: 'grey-background',
  pointerCursor: 'pointer-cursor'
};
